import { DefaultMapOverlays } from "@luciad/ria-sample-common/components/overlay/DefaultMapOverlays";
import { TopLeftButtons } from "@luciad/ria-sample-common/components/overlay/TopLeftButtons";
import { SingleMapSample } from "@luciad/ria-sample-common/components/SingleMapSample";
import { GetFeatureInfoController } from "@luciad/ria-sample-common/controller/GetFeatureInfoController";
import { IToastContext } from "@luciad/ria-sample-common/hooks/useToast";
import { createGridLayer, createWMSBackgroundLayer } from "@luciad/ria-sample-common/LayerFactory";
import { addDragAndDropHandler } from "@luciad/ria-sample-common/util/DragAndDropUtil";
import { loadReferencesFromWKT } from "@luciad/ria-sample-common/util/ReferenceLoader";
import { addReference, parseWellKnownText } from "@luciad/ria/reference/ReferenceProvider";
import { Handle } from "@luciad/ria/util/Evented";
import { Map } from "@luciad/ria/view/Map";
import React from "react";
import ReactDOM from "react-dom";
import { DataFormatsBottomBar } from "./components/DataFormatsBottomBar";
import { addLayer, openFileOrUrl } from "./DataFormatsUtil";

let dragAndDropHandle: Handle | null = null;


const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('wkt')) {
  const wkt = urlParams.get('wkt');
  const wktKey = urlParams.get('reference');
  const wktReference = parseWellKnownText(decodeURIComponent(wkt!));
  addReference(wktReference, wktKey!);
}
  

// let wktBritish = 'PROJCS["OSGB36 / British National Grid",GEOGCS["Ordnance Survey of Great Britain 1936",DATUM["Ordnance Survey of Great Britain 1936",SPHEROID["Airy_1830",6377563.396,299.3249646],TOWGS84[446.448,-125.157,542.06,0.15,0.247,0.8420000000000001,-20.488999999956903]],PRIMEM["Greenwich",0.0],UNIT["Degrees",0.017453292519943295]],PROJECTION["Transverse_Mercator"],PARAMETER["latitude_of_origin",49.0],PARAMETER["longitude_of_origin",-2.0],PARAMETER["scale_factor",0.9996012717],PARAMETER["false_northing",-100000.0],PARAMETER["false_easting",400000.0],UNIT["Meters",1.0],AXIS["Easting",EAST],AXIS["Northing",NORTH]]';
// let referenceBritish = parseWellKnownText(wktBritish);
// addReference(referenceBritish, "EPSG:27700");

const init = async (map: Map, toastCtx: IToastContext) => {
  map.globeColor = "#15202d";

  dragAndDropHandle = addDragAndDropHandler(map.domNode, (files: FileList) => {
    for (const file of files) {
      openFileOrUrl(map, file).catch(err => {
        toastCtx.showErrorToast(`Error opening file ${err.message}`, err);
      });
    }
  });

  map.controller = new GetFeatureInfoController({ requestOnlyOnClick: true })

  await addDefaultDataAndGrid(map);


  // const model = new OGCAPITilesFeatureModel("", map.mapBounds);

  // const layer = new OGCAPITilesFeatureLayer(model, {
  //   id: "bla",
  //   label: "Blabla"
  // });

  // map.layerTree.addChild(layer, "top");
}

const destroy = (_map: Map) => {
  dragAndDropHandle?.remove();
}

const addDefaultDataAndGrid = async (map: Map): Promise<void> => {
  //#snippet addgridlayer
  const gridLayer = createGridLayer();
  map.layerTree.addChild(gridLayer);
  //#endsnippet addgridlayer

  const backgroundLayer = await createWMSBackgroundLayer(map);
  await addLayer(map, backgroundLayer, true);
}

// increase the number of supported coordinate references in this sample
async function loadReferences() {
  const wktReferences = await fetch("/sampledata/projection/epsg_coord_ref.txt").then(r => r.text());
  return await loadReferencesFromWKT(wktReferences);
}

loadReferences().then(() => {
  ReactDOM.render(
    <SingleMapSample
      defaultReference="EPSG:3857"
      includeBackground={false}
      includeElevation={false}
      bottomBar={<DataFormatsBottomBar />}
      onInit={init}
      onDestroy={destroy}
      mapOverlay={<DefaultMapOverlays
        topLeftButtons={(map) => <TopLeftButtons map={map} swipeFlicker={true} />}
      />}
    />,
    document.getElementById("root")
  )
});
